import React, { useState } from "react";
import Footer from "../Fotter";

function FAQ() {
  // State to track which question is open
  const [openIndex, setOpenIndex] = useState(null);

  // Toggle the answer visibility
  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="container mx-auto px-4 py-6">
        {/* Shipping Information Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Shipping Information</h2>
          <p className="text-black mb-2 font-medium">Why Should I Buy From GWS Shopsy?</p>
          <p className="text-gray-600 mb-2">
            GWS Shopsy Deliver Better Quality Products As Customer Needs. GWS Shopsy Is Always Tries To Give Better Customer Service To Their Buyers. GWS Shopsy Have The Widest Selection Of Electronics Products & Others!
          </p>
          <p className="text-black font-medium">What Are The Payment Methods?:</p>
          <ul className="mt-2 text-gray-600 list-disc pl-6">
            <li>GWS Shopsy Payment Options Are –</li>
            <li>– UPI</li>
            <li>– Internet Banking</li>
            <li>– Credit/Debit Card</li>
          </ul>
        </div>

        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Does GWS Shopsy Deliver Products Outside India?</h2>
          <p className="text-gray-600 mb-2">GWS Shopsy Is An Indian Shopping Store!</p>
          <p className="text-gray-600 mb-2">
            We Deliver Products Pan India!  </p>
          <p className="text-black font-medium">What Is Refurbished Product?</p>
          <p className="text-gray-600 mb-2">Refurbishment Is The Distribution Of Products That Have Been Previously Returned To A Manufacturer Or Vendor For Various Reasons, Not Sold In The Market Or New Launch Of A Product!</p>
        </div>

        {/* FAQ Section */}
        <h1 className="text-3xl font-bold mb-6">Frequently Asked Questions</h1>

        {/* Question 1 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(0)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            {" "}
            Why SHould I Buy From GWS Shopsy
          </button>
          {openIndex === 0 && (
            <p>GWS Shopsy Deliver Better Quality Products As Customer Needs.<br />
              GWS Shopsy Is Always Tries To Give Better Customer Service To Their Buyers.<br />
              GWS Shopsy Have The Widest Selection Of Electronics Products & Others</p>
          )}
        </div>

        {/* Question 2 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(1)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is The Expected Delivery Time ?
          </button>
          {openIndex === 1 && (
            <p className="mt-2 text-gray-600 px-4">
              GWS Shopsy Deliver Products Within 5-6 Working Days!
            </p>
          )}
        </div>

        {/* Question 3 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(2)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            Why Should I Buy From GWS Shopsy?
          </button>
          {openIndex === 2 && (
            <ul className="mt-2 text-gray-600 px-4 list-disc">
              <li>
                GWS Shopsy Deliver Better Quality Products As Customer Needs.
              </li>
              <li>
                GWS Shopsy Is Always Tries To Give Better Customer Service To
                Their Buyers.
              </li>
              <li>
                GWS Shopsy Have The Widest Selection Of Electronics Products &
                Others!
              </li>
            </ul>
          )}
        </div>

        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(2)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            Cash On Delivery Available Or Not?
          </button>
          {openIndex === 3 && (
            <ul className="mt-2 text-gray-600 px-4 list-disc">
              <li>
                GWS Shopsy Don’t Have COD On Any Product Yet! </li>
            </ul>
          )}
        </div>

        {/* Question 4 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(3)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is Refurbished Product?
          </button>
          {openIndex === 4 && (
            <p className="mt-2 text-gray-600 px-4">
              Refurbishment Is The Distribution Of Products That Have Been Previously Returned To A Manufacturer Or Vendor For Various Reasons, Not Sold In The Market Or New Launch Of A Product!
            </p>
          )}
        </div>

        {/* Question 5 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(4)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is Open Box Product?
          </button>
          {openIndex === 5 && (
            <p className="mt-2 text-gray-600 px-4">
              An Item That Is An ‘Open-Box’ Product Has Been Opened Before It Was Returned To The Retail Store Or To The Manufacturer!
            </p>
          )}
        </div>

        {/* Question 6 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(5)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            Is There Any Warranty Available On Products?
          </button>
          {openIndex === 6 && (
            <p className="mt-2 text-gray-600 px-4">
              GWS Shopsy All Products Have Warranties But In Different-different
              Slabs <br />Example All Refurbished Products Have 6 Months – 1 Year
              GWS Shopsy Warranty They Do Not Have Any Kind Of Company Warranty!
            </p>
          )}
        </div>

        {/* Question 7 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(6)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is Your Refund And Return Policy?
          </button>
          {openIndex === 7 && (
            <p className="mt-2 text-gray-600 px-4">
              GWS Shopsy Refund & Return Policies Are Well Mentioned Here –
            </p>
          )}
        </div>

        {/* Question 8 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(8)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Should I Do If I Received Damage/Defective OR Wrong Product?
          </button>
          {openIndex === 7 && (
            <p className="mt-2 text-gray-600 px-4">
              First Capture Some Pictures Or Video Of Your Received Product And
              Share With GWS Shopsy Customer Care If They Found That The Product
              Is Actually Damage/Defective Or Wrong; Then The Product Will Be
              Replaced As Soon As Possible!
            </p>
          )}
        </div>

        {/* Question 9 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(8)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Are There Any Cancellation Charges?
          </button>
          {openIndex === 9 && (
            <p className="mt-2 text-gray-600 px-4">
              GWS Shopsy Takes No Charges For Order Cancellation!
            </p>
          )}
        </div>
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(8)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            Does GWS Shopsy Delivery Product Outside India ?
          </button>
          {openIndex === 10 && (
            <p className="mt-2 text-gray-600 px-4">
              GWS Shopsy Is An Indian Shopping Store! <br />
              We Deliver Products Pan India!            </p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FAQ;
